/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceServiceAccountSummary extends models.ComplianceTenantSummary {
    getFixupPrototypeFunction() { return ComplianceServiceAccountSummary.fixupPrototype; }

    static newInstance(model: Partial<ComplianceServiceAccountSummary>): ComplianceServiceAccountSummary {
        let obj = Object.assign(new ComplianceServiceAccountSummary(), model);
        ComplianceServiceAccountSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceServiceAccountSummary>): ComplianceServiceAccountSummary {
        if (!model) return null;
        return ComplianceServiceAccountSummary.newInstance(<ComplianceServiceAccountSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceServiceAccountSummary) {
        if (!obj) return;

        models.ComplianceServiceAccountSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceServiceAccountSummary): boolean {
        if (models.ComplianceTenantSummary.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceServiceAccountSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

}
